export const TARGET_TEXT_STYLE = { fontSize: { base: 'md', sm: 'xl' } }
